import MemberActivityPage from "./MemberActivityPage";

export default MemberActivityPage;
